// api.js
export const API_BASE_URL = 'https://housing.vpmrd.in/api/v1';